import { adminMenus, gclientMenus, kfgwaMenus, userMenus } from '../menus';
import {
  getSubMatMenuProfile,
  shouldHideMenuBySubMatProfile,
} from './subMatCompany';

/** prod(.env.production)에서만 끈다. local·dev에는 두지 않는다. */
const showFolderMenu = process.env.REACT_APP_FOLDER_MENU !== 'false';
const FOLDER_MENU_IDS = ['material_approvement_new', 'g04docu_manage_new'];

const hideFolderMenus = (items) => {
  if (showFolderMenu || !items) return items;
  return items
    .filter((menu) => !FOLDER_MENU_IDS.includes(menu.id))
    .map((menu) => (
      menu.submenus
        ? { ...menu, submenus: hideFolderMenus(menu.submenus) }
        : menu
    ));
};

const filterMenusBySubMatProfile = (menus, sessionUser) => {
  const profile = getSubMatMenuProfile(sessionUser);
  if (profile === 'default' || profile === 'mixed') {
    return menus;
  }

  const filterTree = (items) => items.reduce((acc, menu) => {
    if (menu.id && shouldHideMenuBySubMatProfile(menu.id, profile)) {
      return acc;
    }
    const next = { ...menu };
    if (menu.submenus?.length) {
      next.submenus = filterTree(menu.submenus);
      if (next.submenus.length === 0) {
        return acc;
      }
    }
    acc.push(next);
    return acc;
  }, []);

  return filterTree(menus);
};

/** menus의 mobile 속성으로 모바일 전용 메뉴만 필터링 
 * @param {Array} menus - 메뉴 배열
 * @param {Object} sessionUser - 세션 사용자 (ADMIN 타입이면 전체 메뉴 반환)
 */
export const getMobileMenus = (menus, sessionUser) => {
  if (!menus || !Array.isArray(menus)) return [];
  
  // 시스템관리자(ADMIN)는 모바일에서도 전체 메뉴 표시
  if (sessionUser && sessionUser.type === 'ADMIN') {
    return menus;
  }
  
  return menus
    .filter((menu) => menu && menu.mobile)
    .map((menu) => {
      if (menu.submenus && menu.submenus.length > 0) {
        const mobileSubmenus = menu.submenus
          .filter((sub) => sub && sub.mobile)
          .map((sub) => {
            if (sub.submenus && sub.submenus.length > 0) {
              return {
                ...sub,
                submenus: sub.submenus.filter((s) => s && s.mobile),
              };
            }
            return sub;
          })
          .filter((sub) => !sub.submenus || sub.submenus.length > 0);
        return { ...menu, submenus: mobileSubmenus };
      }
      return menu;
    })
    .filter((menu) => !menu.submenus || menu.submenus.length > 0);
};

export const getMenusByUserType = (sessionUser) => {
  if (!sessionUser) return hideFolderMenus(userMenus);

  if (sessionUser.type === 'ADMIN') return hideFolderMenus(adminMenus);

  let baseMenus;
  if (sessionUser.type === 'GCLIENT') {
    baseMenus = sessionUser.bizRegNumber === '220-82-07388'
      ? kfgwaMenus
      : gclientMenus;
  } else {
    baseMenus = userMenus;
  }

  return hideFolderMenus(filterMenusBySubMatProfile(baseMenus, sessionUser));
};

/**
 * 현재 pathname에 맞는 메뉴 조상 Accordion id 목록.
 * Navigation.renderMenuItems의 menuId(`level-index-title`)와 동일 규칙.
 * @returns {string[]|null} 찾으면 조상 id 배열(리프 자신 제외), 없으면 null
 */
export const collectExpandedMenuIds = (menuItems, pathname, level = 0) => {
  if (!menuItems?.length || !pathname) return null;
  for (let index = 0; index < menuItems.length; index += 1) {
    const menu = menuItems[index];
    const menuId = `${level}-${index}-${menu.title}`;
    if (menu.href === pathname) {
      return [];
    }
    if (menu.submenus?.length) {
      const childIds = collectExpandedMenuIds(menu.submenus, pathname, level + 1);
      if (childIds) {
        return [menuId, ...childIds];
      }
    }
  }
  return null;
};
